import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const alarmQuestionService = {
    list: async (payload) => axios.post(API_URL + "/alarmQuestion/list", payload).then(({ data }) => data).catch((err) => { throw err }),

    getById: async (id) => axios.get(API_URL + `/alarmQuestion/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    create: async (payload) => axios.post(API_URL + "/alarmQuestion", payload).then(({ data }) => data).catch((err) => { throw err }),

    update: async (id, payload) => axios.put(API_URL + `/alarmQuestion/${id}`, payload).then(({ data }) => data).catch((err) => { throw err }),

    remove: async (id) => axios.delete(API_URL + `/alarmQuestion/${id}`).then(({ data }) => data).catch((err) => { throw err }),
};

export default alarmQuestionService;